export default "__VITE_ASSET__CWwAOJhh__"